import React from 'react';
import cl from "./CountriesPageMenuItem.module.css";

const CountriesPageMenuItem = ({id, title, selected, onClick}) => {
    return (
        <button
            className={selected ? `${cl.buttonMain} ${cl.buttonSelected}` : cl.buttonMain}
            onClick={onClick}
        >
            <span className={cl.title}>{title}</span>
        </button>
    );
};

export default CountriesPageMenuItem;